module.exports = __webpack_public_path__ + "static/media/feature-dollar.98e5f335.svg";